import { baseFetchPosts } from 'dash-front/campaign/actions/posts';
import { baseFetchPostsPagination } from 'dash-front/campaign/actions/withPagination';

const fetchAction = baseFetchPosts(null);
export const fetchPostsByCampaigns = campaignIds => baseFetchPostsPagination(() => 'hub', fetchAction)(...campaignIds);
export const fetchPostsByCampaignsAndStatuses = (campaignIds, statuses) =>
    baseFetchPostsPagination(() => 'hub', baseFetchPosts(statuses))(...campaignIds);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/actions/posts.js
 **/